import Vue from 'vue'
import Vuex from 'vuex'
import currentPlan from './modules/currentPlan'
import custom from './modules/custom'
import selectOptions from './modules/selectOptions'
import systemConfig from './modules/systemConfig'
import permission from './modules/permission'
import app from './modules/app'
import getters from './getters'
Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    level: [{id: 1, name: '高起专'}, {id: 2, name: '专升本'}, {id: 3, name: '高起本'}],
    cardTypeList: [{id: 1, name: '身份证'}, {id: 2, name: '护照'}, {id: 3, name: '士官证'}, {id: 4, name: '港澳台身份证'},],
    userInfo: {},
    pageThis : null,
    // 未读消息数量
    sUnReadMsgCount:0
  },
  mutations: {
    setUserInfo : (state,data) => {
      state.userInfo = data
    },
    SAVE_PAGE_THIS (state,_this) {
      state.pageThis = _this
    },
    updateUnReadMsgCount (state,count) {
      state.sUnReadMsgCount = count;
    },
  },
  actions: {
  },
  getters,
  modules: {
    custom,
    currentPlan,
    selectOptions,
    systemConfig,
    permission,
    app,
  }
})
